(function (angular) {
    'use strict';

    angular
        .module('app.tos', []);
        
})(angular);
